// export const SERVER_URL = "https://14barber-backend.vercel.app/api/v1"
// export const SERVER_URL = "http://localhost:5001/api/v1"
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
